import { useContext, useEffect, useState } from 'react';
import { Menu, MenuItem, ListItem, ListItemText, Divider } from '@material-ui/core';
import { ExitToApp as SignOutIcon, AccountCircle as UserMenuIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';


let UserMenu = () => {
    let authService = useContext(authContext);

    let [tokenEmail, setTokenEmail] = useState<string | null>('');
    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    useEffect(() => {
        authService.getEmailFromToken().then(data => setTokenEmail(data));
    }, [])


    return (
        <>
            <ListItem id="login-menu" button onClick={(e: any) => setAnchorEl(e.currentTarget)}>
                <ListItemText primary={<UserMenuIcon />} />
            </ListItem>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem disabled>{tokenEmail}</MenuItem>
                <Divider />
                <MenuItem
                    onClick={() => {
                        setAnchorEl(null);
                        authService.signOut();
                    }}
                >
                    <SignOutIcon />&nbsp;&nbsp;Logout
                </MenuItem>
            </Menu>
        </>
    )
}

export default UserMenu;